import { createAdminWrittenAccountPreviews } from "./AdminWrittenAccountPreviews";

export const AdminWrittenAccountPreviewsOpen = createAdminWrittenAccountPreviews(
	"admin_written_accounts_open",
	(account) =>
		account.hasBeenActive && account.status !== "closed" && account.status !== "declined",
);
